export const mapValidationToInputHelpers = (validation) =>
  validation.error.issues.reduce((out, e) => {
    out[e.path[0]] = {
      type: 'error',
      value: e.message,
    };
    return out;
  }, {});
